<template>
  <b-card no-body style="border: none;" class="h-100">
    <b-tabs class="h-100" nav-wrapper-class="h-15" content-class="h-85">
      <!-- Render Tabs, supply a unique `key` to each tab -->
      <b-tab
        v-for="(trace, idx) in traces"
        :key="`${uuid}-dyn-tab-${trace.id}`"
        :id="`dataset-${trace.id}`"
        :title="'Dataset ' + (idx + 1)"
        class="h-100 p-3"
        :active="trace.id === currentTraceId"
        @click.prevent="clickTab">
        <component v-bind:is="selectedTraceForm" @closeTab="closeTab" :chartUUID="uuid"></component>
      </b-tab>

      <!-- New Tab Button (Using tabs-end slot) -->
      <template v-slot:tabs-end v-if="selectedTraceForm !== 'trace-style-form'">
        <b-nav-item @click.prevent="newTab" href="#" :disabled="disableTabCount">
          <!--Disable the function for multiple traces when over 500,000 points-->
          <!--TODO: Use DA to enable/disable multiple traces-->
          <!--TODO: Create ability to do multiple traces-->
          <b-icon v-if="!disableTabCount" icon="plus"></b-icon>
        </b-nav-item>
      </template>

      <!-- Render this if no tabs -->
      <template v-slot:empty>
        <div class="text-center text-muted p-3">
          There are no datasets.
          <div v-if="selectedTraceForm !== 'trace-style-form'">
            <br />Add new dataset using the
            <b-icon icon="plus"></b-icon> button above.
          </div>
        </div>
      </template>
    </b-tabs>
  </b-card>
</template>

<script>
import _ from 'lodash';
import { mapActions, mapGetters } from 'vuex';
import TraceFormVue from './select-parameters/TraceForm';
import { traceTemplate } from '../../../utils/constants';

export default {
  props: ['componentName', 'selectedTraceForm', 'chartUUID'],
  components: {
    'trace-form': TraceFormVue,
  },
  data() {
    return {
      disableTabCount: false,
    };
  },
  computed: {
    ...mapGetters('visualization/traces', {
      getTraces: 'findByUUID',
      traceId: 'currentId',
      getTrace: 'find',
      isTabExists: 'exists',
    }),
    ...mapGetters('visualization/charts', {
      getChart: 'find',
      charts: 'list',
      chartsLength: 'count',
    }),
    uuid() {
      return this.chartUUID;
    },
    chart() {
      if (this.chartsLength === 0) {
        return null;
      }
      return this.getChart(this.uuid);
    },
    chartLayout() {
      return this.chart.chart.layout;
    },
    chartOptions() {
      return this.chart.chart.options;
    },
    traces() {
      return this.getTraces(this.uuid);
    },
    currentTrace() {
      if (this.$route.query.d) {
        return this.getTrace(this.$route.query.d);
      }
      return null;
    },
    currentTraceId() {
      if (this.currentTrace) {
        return this.currentTrace.id;
      }
      return 0;
    },
  },
  async mounted() {
    /** If traces is empty for this chart, create one */
    if (this.traces.length === 0) {
      await this.newTab();
    }
    /** Disable adding any more tabs after only one is created */
    if (this.traces.length === 1) {
      this.disableTabCount = true;
    }
  },
  methods: {
    ...mapActions('visualization/traces', ['addTrace', 'removeTrace', 'updateTabIndex']),
    ...mapActions('visualization/charts', ['setCurrentTab', 'updateChartQuery']),
    closeTab(id) {
      this.removeTrace({ uuid: this.uuid, traceId: id });
    },
    /**
     * Create new dataset tab from trace template
     */
    async newTab() {
      /** Deep copy from the trace template */
      let newTrace = _.defaultsDeep({}, traceTemplate);
      let override = false;
      if (_.has(this.$route.query, 'd')) {
        /**
         * Assign the passed in query d as trace id,
         * Checks if the tab exists, if not then use
         * the id that's in the query d value
         */
        if (!this.isTabExists(this.$route.query.d)) {
          newTrace = {
            ...newTrace,
            id: JSON.parse(this.$route.query.d),
          };
          override = true;
        }
      }
      const trace = await this.addTrace({ uuid: this.uuid, trace: newTrace, override });
      this.routeToDataset(trace.id);
    },
    /**
     * Pushes a new route history to URL
     * @param {string} id - Dataset id
     */
    routeToDataset(id) {
      const query = {
        ...this.$route.query,
        d: id,
      };
      this.$router.push({ query }).catch((err) => err);
      this.updateChartQuery({ uuid: this.uuid, query });
    },
    /**
     * Route url during a tab click event
     * @param {Object} e - DOM Event object
     */
    clickTab(e) {
      // eslint-disable-next-line radix
      const targetId = parseInt(e.target.id.split('___')[0].split('-')[1]);
      this.routeToDataset(targetId);
    },
    /**
     * Disables tab when there are more than 500K
     * data points. As of 8/4/2022 not in use
     * may revisit in the future.
     */
    // disableTab() {
    //   const checkDataPoints = this.dataPointsCount;
    //   if (checkDataPoints <= 500000) {
    //     this.disableTabCount = false;
    //     return this.disableTabCount;
    //   }
    //   return this.disableTabCount;
    // },
  },
  watch: {
    /**
     * React to route changes,
     * currently create new tab if no traces found
     */
    $route() {
      if (this.traces.length === 0) {
        this.newTab();
        /** Disable adding any more tabs after only one is created */
        this.disableTabCount = true;
      }
    },
  },
};
</script>

<style>
.data-form-dropdown {
  background: #ffffff !important;
}

.tag-search-label {
  color: #000000 !important;
}

.h-15 {
  height: 15% !important;
}

.h-85 {
  height: 85% !important;
}
</style>
